<template>
  <div class="energyReportWrap mainPageBg">
    <div class="conditionWrap ashComWrap">
      <el-form :inline="true" size="small">
        <el-form-item label="周期">
          <el-select v-model="timeType" @change="getDataValue">
            <el-option label="月" value="MONTH"></el-option>
            <el-option label="年" value="YEAR"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <template v-if="timeType !== 'UNLIMITED'">
            <el-date-picker
              size="small"
              :clearable="false"
              v-model="timeValue"
              :type="timeType == 'MONTH' ? 'month' : 'year'"
              :key="timeType == 'MONTH' ? 'month' : 'year'"
              :placeholder="timeType == 'MONTH' ? '选择月' : '选择年'"
              :value-format="timeType == 'MONTH' ? 'yyyy-MM' : 'yyyy'"
              :picker-options="
                timeType == 'MONTH' ? pickerOptions : pickerOptions1
              "
            >
            </el-date-picker>
          </template>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item v-if="judgeAuthority('baobiao:maintenanceReport:export')">
          <el-button type="primary" icon="el-icon-download" @click="exportWord"
            >WORD</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="dataWrap">
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>能耗总览</h4>
        </div>
        <div class="comContentBox">
          <div class="overviewTab">
            <ul>
              <li></li>
              <li>能耗</li>
              <li>环比</li>
              <li>同比</li>
            </ul>
            <ul v-for="(v, i) in overviewList" :key="i">
              <li>{{ v.name }}</li>
              <li>
                {{ v.consumption }}
              </li>
              <li>{{ v.ringRatio }}</li>
              <li>{{ v.yearOnYear }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>节能减排</h4>
        </div>
        <div class="comContentBox">
          <ul class="classification">
            <li v-for="(v, i) in classificationList" :key="i">
              <p>{{ v.num }}</p>
              <h5>{{ v.name }}</h5>
            </li>
          </ul>
        </div>
      </div>
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>光伏发电量</h4>
        </div>
        <div class="comContentBox" style="overflow: auto">
          <el-descriptions
            :column="1"
            size="small"
            border
            style="margin: 10px 20px"
          >
            <el-descriptions-item
              v-for="(v, i) in electricList"
              :key="i"
              :label="v.name"
              :contentStyle="{ 'text-align': 'center', color: '#28CCCB' }"
              :labelStyle="{ 'text-align': 'center' }"
              >{{ v.value.toFixed(2) }}kw·h</el-descriptions-item
            >
          </el-descriptions>
        </div>
      </div>
    </div>
    <div class="chartsWrap">
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>区域能耗Top5</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'getRegionImg'"
            :chartsData="regionList"
            :type="'roseChart'"
          />
        </div>
      </div>
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>部门能耗Top5</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'getDepartmentImg'"
            :chartsData="departmentList"
            :type="'horizontalBar'"
          />
        </div>
      </div>
      <div class="row ashComWrap">
        <div class="comTitle">
          <h4>系统能耗Top5</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'getSystemImg'"
            :chartsData="systemList"
            :type="'horizontalBar'"
          />
        </div>
      </div>
    </div>
    <div class="trendWrap ashComWrap">
      <div class="comTitle">
        <h4>用电趋势</h4>
      </div>
      <div class="comContentBox">
        <PublicEcharts
          :id="'getImgId'"
          :chartsData="chartsData"
          :type="'lightLine'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { dateFtt, judgeAuthority } from "@/assets/js/utils";
import { exportWord } from "@/assets/utils/exportWord";
import PublicEcharts from "@/components/PublicEcharts.vue";
import api from "@/api";
export default {
  components: {
    PublicEcharts,
  },
  data() {
    return {
      timeValue: "",
      timeType: "MONTH",
      overviewList: [],
      classificationList: [
        { name: "综合节能率", num: "", key: "range" },
        { name: "减少CO₂排放", num: "", key: "reduceCO2" },
        { name: "等效植树", num: "", key: "EquivalentTree" },
        { name: "节约标准煤", num: "", key: "reduceCoal" },
      ],
      electricList: [],
      chartsData: { title: "", unit: "kw·h", xData: [], dataArr: [] },
      regionList: {
        unit: "kw·h",
        dataArr: [],
      }, //区域
      departmentList: {
        name: "部门能耗",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      systemList: {
        name: "系统能耗",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      regionImg: "",
      departmentImg: "",
      systemImg: "",
      img: "",
      departmentTab: [],
      systemTab: [],
      regionTab: [],
      tableData: {
        tableHeader: [],
        table: [],
      },
      pickerOptions: {
        disabledDate(time) {
          let t = new Date().getDate();
          return time.getTime() > Date.now() - 8.64e7 * t;
        },
      },
      pickerOptions1: {
        disabledDate(time) {
          // return time.getTime() > Date.now() - 8.64e6;
          const now = new Date();
          const currentYear = now.getFullYear();
          // 设置当年及以后的日期为不可选
          return time.getFullYear() >= currentYear;
        },
      },
    };
  },
  methods: {
    judgeAuthority,
    exportWord() {
      let data = {
        title: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0]
          .projectName,
        time:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
        regionImg: this.regionImg,
        departmentImg: this.departmentImg,
        systemImg: this.systemImg,
        img: this.img,
        departmentTab: this.departmentTab,
        systemTab: this.systemTab,
        overviewList: this.overviewList,
        electricList: this.electricList,
        regionTab: this.regionTab,
        classificationList: this.classificationList,
        tableData: this.tableData,
      };
      exportWord(data);
    },
    onSubmit() {
      this.getOverview();
      this.getConservation();
      this.getPhotovoltaic();
      this.getEnergyConsumption(); //分项系统
      this.getRegion(); //区域能耗
      this.getDepartment(); //部门能耗
      this.getElectricity();
    },
    getDataValue() {
      if (this.timeType == "YEAR") {
        // this.timeValue = dateFtt("yyyy", new Date());
        this.timeValue = (new Date().getFullYear() - 1).toString();
      } else if (this.timeType == "MONTH") {
        this.timeValue = this.$moment(new Date())
          .subtract("1", "M")
          .format("YYYY-MM");
      } else {
        this.timeValue = null;
      }
    },
    // 能耗总览
    async getOverview() {
      let res = await api.formECOverview({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
      });
      if (res && res.data.code == 200) {
        this.overviewList = [];
        this.overviewList = (res.data.data || []).map((item) => ({
          ...item,
          consumption:
            item.consumption + `${item.name == "用电量" ? "kw·h" : "m³"}`,
        }));
      }
    },
    // 节能减排
    async getConservation() {
      let res = await api.formECConservation({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
      });
      if (res && res.data.code == 200) {
        this.classificationList.map((v) => {
          v.num = res.data.data[v.key];
          if (v.key == "range") {
            v.num += "%";
          } else if (v.key == "reduceCO2") {
            v.num = this.handleNum(v.num, "kgCO₂e", "tCO₂e", 1000);
          } else if (v.key == "EquivalentTree") {
            v.num = this.handleNum(v.num, "棵", "万棵", 10000);
          } else if (v.key == "reduceCoal") {
            v.num = this.handleNum(v.num, "kg", "t", 1000);
          }
        });
      }
    },
    handleNum(value, unit, handleUnit, num) {
      if (typeof value === "number" && !isNaN(value) && Math.abs(value) > num) {
        return (value / num).toFixed(2) + handleUnit;
      } else {
        return value + unit;
      }
    },

    // 光伏发电量
    async getPhotovoltaic() {
      let res = await api.formECPhotovoltaic({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        label: "逆变器",
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
      });
      if (res && res.data.code == 200) {
        this.electricList = [];
        let arr = res.data.data,
          obj = {};
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].name === "全部发电量") {
            obj = arr[i];
            arr.splice(i, 1);
            break;
          }
        }
        arr.unshift(obj);
        this.electricList = arr;
      }
    },
    async getRegion() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
        label: "区域位置",
      });
      if (res && res.data.code == 200) {
        this.regionList.dataArr = [];
        this.regionTab = Array.from(res.data.data).map((item) => ({
          regionName: item.name,
          regionValue: item.ecValue,
          energyAssetVOs: item.energyAssetVOs,
        }));
        let dataArr = Array.from(res.data.data).map((item) => ({
          name: item.name,
          value: item.ecValue,
        }));
        this.regionList.dataArr = dataArr.slice(0, 5);
      }
    },
    async getEnergyConsumption() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
        label: "分项系统",
      });
      if (res && res.data.code == 200) {
        this.systemList.xData = [];
        this.systemList.yData = [];
        this.systemTab = res.data.data;
        let arr = res.data.data;
        for (let i = 0; i < arr.length; i++) {
          this.systemList.xData.push(arr[i].ecValue);
          this.systemList.yData.push(arr[i].name);
          if (i >= 4) {
            return;
          }
        }
      }
    },
    async getDepartment() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.timeType,
        range:
          this.timeType == "MONTH"
            ? dateFtt("yyyy年MM月", new Date(this.timeValue))
            : dateFtt("yyyy年", new Date(this.timeValue)),
        label: "单位部门",
      });
      if (res && res.data.code == 200) {
        this.departmentList.xData = [];
        this.departmentList.yData = [];
        this.departmentTab = res.data.data;
        let arr = res.data.data;
        for (let i = 0; i < arr.length; i++) {
          this.departmentList.xData.push(arr[i].ecValue);
          this.departmentList.yData.push(arr[i].name);
          if (i >= 4) {
            return;
          }
        }
      }
    },
    async getElectricity() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      let res = await api.equipmentEnergyLineDataList({
        assetId: treeAllData.区域位置.id,
        type: this.timeType == "MONTH" ? "YEAR" : "UNLIMITED",
        date:
          this.timeType == "MONTH"
            ? dateFtt("yyyy", new Date(this.timeValue))
            : "",
        dateType: "ENERGY_CONSUMPTION",
      });
      // console.log(res.data.data.chartParamsList);
      if (res && res.data.code == 200) {
        this.chartsData.xData = [];
        this.chartsData.dataArr = [];
        this.tableData.tableHeader = [];
        this.tableData.table = [];
        let arr = [];
        res.data.data.chartParamsList.map((v) => {
          this.chartsData.xData.push(
            this.timeType == "MONTH"
              ? dateFtt("MM月", new Date(v.time))
              : dateFtt("yyyy年", new Date(v.time))
          );
          arr.push(v.assets);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.chartsData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.chartsData.dataArr[i].name = item[i].name;
            this.chartsData.dataArr[i].data.push(item[i].data);
          });
        }

        let obj = {};
        for (let i = 0; i < 12; i++) {
          obj[i] = this.chartsData.xData[i] ? this.chartsData.xData[i] : "";
        }
        this.tableData.tableHeader.push(obj);
        for (let i = 0; i < this.chartsData.dataArr.length; i++) {
          this.tableData.table.push({
            name: this.chartsData.dataArr[i].name,
          });
          for (let j = 0; j < 12; j++) {
            this.tableData.table[i][j] =
              this.chartsData.dataArr[i].data[j] ||
              this.chartsData.dataArr[i].data[j] == 0
                ? this.chartsData.dataArr[i].data[j]
                : "";
          }
        }
      }
    },
  },
  created() {
    this.getDataValue();
    this.onSubmit();
  },
};
</script>

<style lang="scss" scoped>
.energyReportWrap {
  @include setPage;
  @include setFlexColumn;
  justify-content: space-between;
  align-items: center;
  .row {
    width: calc(33.3% - 6px);
    height: 100%;
  }
  .conditionWrap {
    width: 100%;
    height: 6%;
    border-radius: 5px;
    @include setFlexStart;
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }
  .dataWrap {
    width: 100%;
    height: 30%;
    @include setFlexBetween;
    .overviewTab {
      width: 95%;
      height: 100%;
      margin: 0 auto;
      ul {
        height: 20%;
        @include setFlexBetween;
        li {
          width: 25%;
          text-align: center;
        }
        li:first-child {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .classification {
      width: 90%;
      height: 100%;
      margin: 10px auto;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        height: 50%;
        @include setFlexColumn;
        justify-content: center;
        align-items: center;
        color: #666;
        h5 {
          margin-top: 20px;
          font-size: 14px;
        }
      }
    }
    .classification::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 0;
      width: 1px;
      height: 100%;
      background-color: #e9e9e9;
    }
    .classification::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
      background-color: #e9e9e9;
    }
  }
  .chartsWrap {
    width: 100%;
    height: 30%;
    @include setFlexBetween;
  }
  .trendWrap {
    width: 100%;
    height: 30%;
  }
}
</style>
